/* eslint-disable @typescript-eslint/no-var-requires */
/// <reference types="@welldone-software/why-did-you-render" />

import { isDev } from '../../common/util/platform';

let shouldEnableWdyrOnLoad = false;

if (typeof window !== 'undefined') {
	const storedValue = sessionStorage.getItem('isWdyrEnabled');

	shouldEnableWdyrOnLoad = storedValue === 'true';
}

if (isDev() && shouldEnableWdyrOnLoad) {
	if (typeof window !== 'undefined') {
		const whyDidYouRender = require('@welldone-software/why-did-you-render');

		whyDidYouRender(require('react'), {
			collapseGroups: true,
			// This is a workaround for the issue with WDYR not working with Next.js https://github.com/welldone-software/why-did-you-render/issues/272#issuecomment-1645114930
			include: [/./],
			logOnDifferentValues: true
		});
	}
}
